// SCHOOL
export const CALL = `/call`;
export const CALL_PUBLIC = `/public/call`;
export const GOOGLE_TOKEN_PATH = `/token/generate`;
export const LIST_PROVIDER = `/oauth/providers`;
export const GET_ID_USER = `/userinfo`;
export const CREATE = `/create`;
export const CREATE_UPDATE = `/create_update`;
